import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { tailwindMerge } from "@air/tailwind-variants";
import classNames from "classnames";
import { forwardRef, memo } from "react";
import { SearchCommandFilterCount } from "~/components/SearchCommand/SearchCommandFilterCount";
import { SearchCommandModeSelector } from "~/components/SearchCommand/SearchCommandModeSelector";
import { useTemporaryFeatureFlags } from "~/hooks/useTemporaryFeatureFlags";
import { usePrivateSearchContext } from "~/providers/PrivateSearchProvider";
export const _SearchCommandTrigger = /*#__PURE__*/ forwardRef((param, ref)=>{
    let { className, count, placeholder, search, ...restOfProps } = param;
    const { ui2 } = useTemporaryFeatureFlags();
    const { canUseSmartSearch } = usePrivateSearchContext();
    return /*#__PURE__*/ _jsxs("button", {
        className: tailwindMerge("relative flex h-10 w-full items-center gap-2 overflow-hidden whitespace-nowrap border border-grey-5 bg-grey-1 px-3 outline-none ring-2 ring-transparent transition-[box-shadow] hover:ring-black/[0.04] dark:hover:ring-white/[0.025]", className, ui2 ? "rounded-8" : "rounded-4", canUseSmartSearch && "pl-2 pr-3"),
        "data-testid": "SEARCH_COMMAND_TRIGGER",
        "data-value": search,
        ref: ref,
        ...restOfProps,
        children: [
            /*#__PURE__*/ _jsx(SearchCommandModeSelector, {
                search: search
            }),
            /*#__PURE__*/ _jsx("span", {
                className: classNames("text-16 font-medium", !search ? "text-grey-9" : "text-grey-12"),
                children: search ? /*#__PURE__*/ _jsx("span", {
                    "data-testid": "SEARCH_COMMAND_TRIGGER_VALUE",
                    children: search
                }) : /*#__PURE__*/ _jsx("span", {
                    "data-testid": "SEARCH_COMMAND_TRIGGER_PLACEHOLDER",
                    children: placeholder
                })
            }),
            !!count && /*#__PURE__*/ _jsx(SearchCommandFilterCount, {
                count: count
            })
        ]
    });
});
_SearchCommandTrigger.displayName = "_SearchCommandTrigger";
export const SearchCommandTrigger = /*#__PURE__*/ memo(_SearchCommandTrigger);
SearchCommandTrigger.displayName = "SearchCommandTrigger";
